import React from 'react';
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faUserCircle, faPencilAlt, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { colors } from '../../../../config/color';
import { Authenticator_Type, Authenticator_Status, APP_LOCAL_DATE_FORMAT } from '../../../../config/constants';
import moment from 'moment';
import ItemGroup from './item-group';

export interface GroupPassSMSProps {
  deleteAuth: Function;
  handleActive: Function;
  resetPassword: Function;
  arrPassSMS: any;
  deleteGroup: Function;
  sendOtp: Function;
  arrUSB: any;
  arrKPI: any;
  arrSmartCA: any;
  count: any;
}

export interface GroupPassSMSState {
  modalShow: boolean;
}

export default class GroupPassAndSMS extends React.Component<GroupPassSMSProps, GroupPassSMSState> {
  state: GroupPassSMSState = {
    modalShow: false
  };
  resetPassword = () => {
    this.props.resetPassword();
  };

  deleteGroupSMS = () => {
    if (this.props.arrUSB.length > 0 || this.props.arrKPI.length > 0 || this.props.arrSmartCA.length > 0) {
      this.props.deleteGroup(Authenticator_Type.SMS);
    } else {
      this.props.deleteGroup(null);
    }
  };

  render() {
    return (
      <div>
        <hr />
        <Row style={{ flex: 1 }}>
          <Col style={{ flex: 0.1 }}>
            {/* <FontAwesomeIcon icon={faUserCircle} size="5x" color={colors.iconUser} /> */}
            <img src={require('../../../../images/avatar_icon.png')} alt="" />
          </Col>
          <Col style={{ flex: 0.7 }}>
            <div>
              <h5 className="font-common">Xác thực bằng mật khẩu, tin nhắn SMS</h5>
            </div>
          </Col>
          {/*<Col style={{ flex: 0.2 }} className="text-center">*/}
          {/*  <Button className="btnDeleteAllGroup" onClick={() => this.deleteGroupSMS()}>*/}
          {/*    <FontAwesomeIcon icon={faTrashAlt} color="#4D9235" />*/}
          {/*  </Button>*/}
          {/*</Col>*/}
        </Row>
        {this.props.arrPassSMS.map(obj => (
          <ItemGroup
            count={this.props.count}
            key={obj.id}
            auth={obj}
            deleteAuth={this.props.deleteAuth}
            handleActive={this.props.handleActive}
            resetPassword={this.resetPassword}
            sendOtp={this.props.sendOtp}
          />
        ))}
      </div>
    );
  }
}
